import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Servitutt from './Servitutt.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'

class ServituttList extends Component {
    state = {
        servitutter: [],
        isServitutterLoaded: false,
        isLoading: false,
        isOpened: false
    }

    getServitutter = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/servitutt/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                servitutter: [...this.state.servitutter, ...data.servitutter],
                isServitutterLoaded: true,
                isLoading: false})
        })
      }


    toggleServitutter = () => {
        if (!this.state.isServitutterLoaded) {
            this.getServitutter()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleServitutter}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={PilIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('servitutter')} {this.state.isServitutterLoaded && `(${this.state.servitutter.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>                    
                </div>
                <div className={this.state.isOpened && this.state.servitutter.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.servitutter.map((s, index) => { return (<Servitutt key={s.dokumentnummer+s.dokumentnavn} servitutt={s} isLast={index==this.state.servitutter.length-1} onEvent={this.props.onEvent} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(ServituttList)